import { render } from "./DropDocuments.vue?vue&type=template&id=353f6555"
import script from "./DropDocuments.vue?vue&type=script&lang=js"
export * from "./DropDocuments.vue?vue&type=script&lang=js"

import "./DropDocuments.vue?vue&type=style&index=0&id=353f6555&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__